import { IFilter } from 'core-components/types'

export const equalFilters = (a: IFilter, b: IFilter) => {
  return a.field === b.field && a.operator === b.operator && a.value === b.value
}
